import { useQuery } from '@tanstack/react-query';

import { defaultRuntimeConfig, loadRuntimeConfig } from '../runtimeConfig';
import { queryKeys } from './queryKeys';

const RUNTIME_CONFIG_POLL_INTERVAL_MS = 5 * 60 * 1000;

export function useRuntimeConfig() {
  const { data } = useQuery({
    queryKey: queryKeys.getRuntimeConfig,
    queryFn: () => loadRuntimeConfig(),
    initialData: defaultRuntimeConfig,
    staleTime: 0,
    refetchInterval: RUNTIME_CONFIG_POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
  });

  return { runtimeConfig: data };
}
